export const logOut = () => {
  localStorage.removeItem('datacenter-access-token');
  localStorage.removeItem('datacenter-refresh-token');
  localStorage.removeItem('datacenter-admin-auths');
  window.location.reload();
  window.location.replace('/');
};
